import { styled } from '@linaria/react';

export const BurstWrapper = styled.div`
	position: relative;
	z-index: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	pointer-events: none;
`;

export const Jumbo = styled.div`
	z-index: 1;
	margin-bottom: -70px;
`;

export const BurstOuter = styled.div`
	position: relative;
	z-index: -1;
	border-radius: var(--radius-xl);
	animation: glow 5s infinite, float 2s infinite;

	&::before {
		position: absolute;
		z-index: -1;
		width: 100%;
		height: 100%;
		border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
		animation: liquid 3s ease-in-out;
		background: linear-gradient(
			45deg,
			#78c4ff -150%,
			var(--color-white-solid) 150%
		);
		content: '';
		filter: blur(6px);
		opacity: 0.8;
		transform: scale(1.15);
		transition: filter 0.2s, transform 0.3s, opacity 0.2s;
	}

	@keyframes liquid {
		0%,
		100% {
			border-radius: 30% 60% 70% 50% / 50% 60% 30%;
			background-size: 250% 150%;
		}
		33% {
			border-radius: 50% 60% 30% / 30% 60% 70% 50%;
			background-size: 150% 300%;
		}
		63% {
			border-radius: 30% 60% 70% 40% / 50% 60% 30%;
			background-size: 350% 250%;
		}
		86% {
			border-radius: 50% 60% 30% / 30% 60% 70% 50%;
			background-size: 150% 300%;
		}
	}
	@keyframes glow {
		0% {
			box-shadow: 0 0 75px 20px var(--color-rose-48-solid);
		}
	}
	@keyframes float {
		0%,
		100% {
			transform: translateY(0);
		}
		40% {
			transform: translateY(2%);
		}
	}
`;

export const BurstInner = styled.div`
	position: relative;
	padding: 80px 48px 48px;
	border-radius: var(--radius-xl);
	background: linear-gradient(
		90deg,
		var(--brand-dark) -10%,
		var(--color-rose-58-solid) 250%
	);

	&::before,
	&::after {
		position: absolute;
		z-index: -1;
		top: 0;
		left: 0;
		width: calc(100% + 12px);
		height: calc(100% + 12px);
		padding: 3px;
		border: 3px solid var(--color-azure-62-solid);
		border-radius: var(--radius-xl);
		margin: -6px;
		content: '';
	}
`;

export const BurstAmount = styled.p`
	color: var(--color-white-solid);
	font-size: var(--font-size-4xl);
	font-weight: var(--font-weight-bold);
	text-align: center;

	span {
		display: block;
		color: var(--color-azure-62-solid);
		font-size: var(--font-size-2xl);
	}
`;
